// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import BasicTableCell from 'Ui/components/common/basic-table/basic-table-cell';

function BasicTableHeader(props) {
    return (
        <div
            className='basic-table-header'
            data-testid='basic-table-header'
        >
            {
                Object.keys(props.cells).map((key) => (
                    <BasicTableCell key={`table-cell ${key}`}>
                        {props.cells[key]}
                    </BasicTableCell>
                ))
            }
        </div>
    );
}

BasicTableHeader.propTypes = {
    cells: PropTypes.row
};

export default BasicTableHeader;
